/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.columnas': 'Columnas',
  'columnas.agregarColumnas': 'Crear Columnas',
  'columnas.modificarColumnas': 'Editar Columnas',
  'columnas.columnaId': 'Columna Id',
  'columnas.empresaId': 'Empresa Id',
  'columnas.descripcionColumna': 'Descripción Columna',
  'columnas.VerColumnas': 'Ver Columnas',
  'columnas.RegistroDuplicado': 'Registro Duplicado',
};
